<template>
  <section class="containerInputPercentage" :class="{'error': isRequiredErrorVisible || error}">
    <label class="containerInputPercentage__label" :class="{'required': required}">% ALLOCATION</label>
    <div class="containerInputPercentage__inputContainer">
      <input class="containerInputPercentage__inputContainer--input"
      type="text"
      min="1"
      @input="updateInput"
      ref="inputValue"
      :id="id"
      :value="percentage"
      :placeholder="placeholder"
      @keypress="validateKeyPress($event)"
      @paste="handlePaste($event)"
      @blur="validateNumber"
      autocomplete="off"
      maxLength="3"
      />
      <span class="containerInputPercentage__inputContainer--icon">%</span>
    </div>
    <span class="errorMessage" v-if="isRequiredErrorVisible || error">{{errorMessage}}</span>
  </section>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
export default {
  name: 'inputPercentage',
  props: {
    id: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    },
    showErrors: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup (props, { emit }) {
    const inputValue = ref(null)
    const percentage = ref(null)
    const error = ref(false)

    /**
     * @description Returns a boolean to indicate that this is a required field and it has not a valid value.
     */
    const isRequiredErrorVisible = computed(() => {
      return props.required && props.showErrors && !props.modelValue
    })

    /**
     * @description Returns the error message to show
     */
    const errorMessage = computed(() => {
      return error.value ? 'The value must be between 1 and 100' : 'This field cannot be empty'
    })

    onMounted(() => {
      setInitialModelValue()
    })

    /**
     * @description Emits the value sets by the user in the input.
     */
    function updateInput (event) {
      error.value = false
      inputValue.value.value = inputValue.value.value.replace(/`|´/g, '')
      percentage.value = inputValue.value.value ? inputValue.value.value : null
      emit('update:modelValue', percentage.value)
    }

    /**
     * @description Set initial value
     */
    function setInitialModelValue () {
      if (props.modelValue) {
        percentage.value = props.modelValue
      } else {
        percentage.value = ''
      }
      validateNumber()
    }

    /**
     * @description Validate that key press is a valid number
     * @param event DOM event
     */
    function validateKeyPress (event) {
      const notNumberRegex = /[^\d]+/g
      if ((notNumberRegex.test(event.key) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(event.code)) || (event.key === '0' && !event.target.value)) event.preventDefault()
    }

    /**
     * @description Validate that paste string has only numbers
     * @param event DOM event
     */
    function handlePaste (event) {
      const pasteString = event.clipboardData.getData('text')
      if (isNaN(pasteString)) event.preventDefault()
    }

    /**
     * @description Validate that the number entered by user is between 1 and 100
     */
    function validateNumber () {
      if (percentage.value && (Number(percentage.value) < 1 || Number(percentage.value) > 100)) error.value = true
    }

    return {
      inputValue,
      updateInput,
      isRequiredErrorVisible,
      percentage,
      validateKeyPress,
      handlePaste,
      validateNumber,
      error,
      errorMessage
    }
  }
}
</script>
